import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Tag, Clock, Users } from "lucide-react";
import { waLink } from "../../data";
import { WhatsAppIcon } from "./WhatsAppIcon";

const pad = (n) => String(n).padStart(2, "0");

function getCountdown() {
  const now = new Date();
  const start = new Date(now);
  start.setHours(6, 0, 0, 0);
  const end = new Date(now);
  end.setHours(22, 0, 0, 0);

  let target;
  let label;
  let active;
  if (now < start) {
    target = start;
    label = "Promo dibuka dalam";
    active = false;
  } else if (now < end) {
    target = end;
    label = "Promo berakhir dalam";
    active = true;
  } else {
    target = new Date(start.getTime() + 24 * 60 * 60 * 1000);
    label = "Promo dibuka dalam";
    active = false;
  }
  const diff = Math.max(0, target - now);
  const totalSec = Math.floor(diff / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  return { h, m, s, label, active };
}

const Unit = ({ value, unit }) => (
  <div className="flex flex-col items-center">
    <span className="font-display text-2xl sm:text-3xl leading-none tabular-nums w-12 text-center rounded-lg bg-[#2c1e16] text-[#faf7f2] py-2">
      {pad(value)}
    </span>
    <span className="mt-1 text-[10px] uppercase tracking-[0.15em] text-[#2c1e16]/70">
      {unit}
    </span>
  </div>
);

export const PromoBanner = () => {
  const [cd, setCd] = useState(getCountdown());
  useEffect(() => {
    const t = setInterval(() => setCd(getCountdown()), 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <section id="promo" className="relative bg-[#b8862f] overflow-hidden grain">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-8 sm:py-10">
        <div className="flex flex-col lg:flex-row items-center gap-6 lg:gap-8">
          <motion.div
            initial={{ scale: 0.6, rotate: -8, opacity: 0 }}
            whileInView={{ scale: 1, rotate: -6, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="shrink-0 flex items-center gap-3 rounded-2xl bg-[#2c1e16] text-[#faf7f2] px-6 py-4"
          >
            <Tag className="h-7 w-7 text-[#b8862f]" strokeWidth={1.75} />
            <div className="leading-none">
              <span className="block uppercase text-[10px] tracking-[0.25em] text-[#e5d9c5]">
                Diskon Setiap Hari
              </span>
              <span className="block font-display text-3xl sm:text-4xl mt-1">
                Diskon Rp50.000
              </span>
            </div>
          </motion.div>

          <div className="flex-1 text-center lg:text-left text-[#2c1e16]">
            <p className="font-display text-2xl sm:text-3xl leading-tight">
              Khusus 10 pelanggan pertama setiap hari.
            </p>
            <div className="mt-3 flex flex-wrap justify-center lg:justify-start gap-x-6 gap-y-2 text-sm font-medium">
              <span className="flex items-center gap-2">
                <Users className="h-4 w-4" /> 10 pelanggan pertama
              </span>
              <span className="flex items-center gap-2">
                <Clock className="h-4 w-4" /> Berlaku jam 06.00 – 22.00
              </span>
            </div>
          </div>

          <div className="shrink-0 flex flex-col items-center gap-3">
            <span
              data-testid="promo-countdown-label"
              className="text-xs uppercase tracking-[0.2em] text-[#2c1e16] font-medium"
            >
              {cd.label}
            </span>
            <div data-testid="promo-countdown" className="flex items-end gap-2">
              <Unit value={cd.h} unit="Jam" />
              <span className="font-display text-2xl text-[#2c1e16] pb-6">:</span>
              <Unit value={cd.m} unit="Menit" />
              <span className="font-display text-2xl text-[#2c1e16] pb-6">:</span>
              <Unit value={cd.s} unit="Detik" />
            </div>
            <a
              href={waLink("Halo Javanese Spa Jogja, saya mau klaim PROMO diskon Rp50.000 untuk 10 pelanggan pertama.")}
              target="_blank"
              rel="noreferrer"
              data-testid="promo-booking-btn"
              className="inline-flex items-center gap-2 rounded-full bg-[#2c1e16] text-[#faf7f2] px-8 py-3.5 text-sm font-medium hover:bg-[#1a1210] transition-colors"
            >
              <WhatsAppIcon className="h-5 w-5 text-[#25D366]" />
              Klaim Promo Sekarang
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
